import { render, staticRenderFns } from "./signUpPC.vue?vue&type=template&id=7180a2de&scoped=true"
import script from "./signUpPC.vue?vue&type=script&lang=js"
export * from "./signUpPC.vue?vue&type=script&lang=js"
import style0 from "./signUpPC.vue?vue&type=style&index=0&id=7180a2de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7180a2de",
  null
  
)

export default component.exports